import React from 'react';
import { TGridLegsOption, TGridOption } from '../../../api/endpoints/SubsetOption';
import { SelectSingleInput } from '../../Inputs/SelectInput';

const GridSelector = (props: {
  values: Array<string>;
  spec: TGridLegsOption | TGridOption,
  onChange: (values: Array<string>) => void;
}) => {
  const { spec, values, onChange } = props;

  const onGridChange = (leg: number) => (value: string) => {
    const newValues = [...values];
    newValues[leg] = value;

    onChange(newValues);
  };

  if ('grid' in spec.value) {
    return (
      <SelectSingleInput
        items={spec.value.grid}
        itemToOption={grid => ({
          value: grid,
          label: grid
        })}
        onChange={
          value => value && onGridChange(0)(value)
        }
        selectedItem={values[0]}
        name="grid"
      />
    );
  }

  if ('legs' in spec.value) {
    return (
      <div className="grid-selector">
        {
          spec.value.legs.map((leg, index) => {
            return <div key={index} className="grid-leg">
              <div className="grid-leg-label">
                Leg {index + 1}:
              </div>
              <SelectSingleInput
                key={index}
                items={leg}
                itemToOption={grid => ({
                  value: grid,
                  label: grid
                })}
                onChange={value => {
                  value && onGridChange(index)(value);
                }}
                selectedItem={values[index]}
                name={`grid-leg-${index + 1}`}
              />
            </div>
          })
        }
      </div>
    );
  }

  return null;
};

export default GridSelector;
